module.exports = __webpack_public_path__ + "img/9_diamonds.7345a525.png";